<template>
    <div class="vat mt-4 position-relative">
    <ldc-select
        v-model="vat"
        placeholder="Chọn thuế Vat"
        class="rv-select-form" v-if="$detect == 'web'">
        <ldc-option
            :value="1"
            label="Có Vat"/>
        <ldc-option
            :value="2"
            label="Chưa Vat"/>
    </ldc-select>
    <ldc-select-mobile
        :showPlaceholder="false"
        placeholder="Chọn thuế"
        title="Loại tin"
        v-model="vat"
        class="select-mobile-post"
        v-else>
        <ldc-option-mobile
            :value="1"
            label="Có Vat"/>
        <ldc-option-mobile
            :value="2"
            label="Chưa Vat"/>
    </ldc-select-mobile>
    <div class="text-position-select position-absolute text-primary">Chọn thuế</div>
    <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
</div>
</template>
<script>
export default {
    props: ['data','error'],
    data() {
        return {
            vat: ''
        }
    },
    watch: {
        data(val){
            this.vat = val*1;
        },
        vat(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.vat = this.data*1;
    }
}
</script>
<style lang="scss">
.rv-create {
    .body {
        .rv-select-form {
            .ldc-input {
                border: 1px solid rgba(0, 0, 0, 0.2) !important;
                color: #000;
                font-size: 16px !important;
                height: unset !important;
                line-height: unset !important;
                padding: 10px !important;
                border: 1px solid #007bff !important;
            }
        }
        .select-mobile-post {
            border: 1px solid #007bff;
            border-radius: 4px;
            .ldc-placeholder-select-mobile {
                border-radius: 4px;
                i {
                    float: right;
                }
            }
        }
        .text-position-select {
            top: -13px;
            padding: 0 10px;
            background: #fff;
            margin-left: 10px;
        }
    }
}
</style>
